import { SafeUrl } from '@angular/platform-browser';

type Url = string | SafeUrl;

/**
 * @deprecated older code uses untyped detailsitems, prefer SimpleDetailsItem or other typed versions
 */
export interface DetailsItem {
  name: string;
  value: string;
  cssClass: string;
}

export interface SimpleDetailsItem extends DetailsItem {
  kind: 'simple';
}

export interface BlankDetailsItem extends DetailsItem {
  kind: 'blank';
}

export interface AnchorDetailsItem {
  kind: 'anchor';
  name: string;
  href: Url;
  value: string;
  openNewTab: boolean;
}

export type DetailsItemType =
  | AnchorDetailsItem
  | DetailsItem
  | SimpleDetailsItem
  | BlankDetailsItem;


export type DetailsItemTypesArray = Array<DetailsItemType>

export function isUnTypedDetailsItem(v: DetailsItemType) {
  return (v as any).kind === undefined;
}

export function simple(name: string, value: string, cssClass: string = null): SimpleDetailsItem {
  return {
    kind: 'simple',
    name: name,
    value: value,
    cssClass: cssClass
  }
}

export function anchor(name: string, href: Url, value: string, openNewTab: boolean = false): AnchorDetailsItem {
  return {
    kind: 'anchor',
    name: name,
    href: href,
    value: value,
    openNewTab: openNewTab
  }
}

export function nameOnly(name: string) {
  return simple(name, null, null);
}

export function blank() {
  return {
    kind: 'blank', name: null, value: null, cssClass: null
  }
}



